import React, { useState, useContext, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './NavBar.css';
import UserDropdown from '../layout/UserNav';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { AuthContext } from '../../contexts/AuthContext';
import routes from '../../utils/routes';
import logo from '../../assets/images/full_logo_color.svg';

function NavLink({ link, text, onClick }) {
  return (
    <Link to={link} className="nav-link" onClick={onClick}>{text}</Link>
  );
}

function Menu({ isOpen, toggleMenu }) {
  return (
    <button
      className={`common-button mobile-menu-icon ${isOpen ? "open" : ""}`}
      onClick={toggleMenu}
    >
      <div className="menu-bar1"></div>
      <div className="menu-bar2"></div>
    </button>
  )
}

function NavBar() {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const { isLogged, logout } = useContext(AuthContext);

  const loggedUserNavItems = [
    { text: 'Mi perfil', icon: "account_circle", link: routes.profile },
    { text: 'Cerrar sesión', icon: "logout", onClick: logout, link: routes.home },
  ];
  
  const newUserNavItems = [
    { text: 'Iniciar Sesion', icon: "account_circle", link: routes.login },
    { text: 'Registrarse', icon: "shopping_cart", link: routes.login },
  ];

  const userNavItems = isLogged ? loggedUserNavItems : newUserNavItems;

  const toggleMenu = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  return (
    <nav className="navbar">
      <div className="navblock">
        <Link to={routes.home} className="navbar-logo">
          <img src={logo} alt="Brand logo" className="logo" />
        </Link>
        <ul
          className={isOpen ? "nav-links-mobile" : "nav-links"}
          onClick={() => setIsOpen(false)}
        >
          <Link to={routes.home} className="nav-link">Inicio</Link>
          <Link to={routes.products} className="nav-link">Productos</Link>
          <Link to={routes.about} className="nav-link">Nosotros</Link>
          {isMobile &&
            userNavItems.map((item, index) => (
              <NavLink key={index} {...item} />
            ))
          }
        </ul>
        {isMobile ? (
          <Menu isOpen={isOpen} toggleMenu={toggleMenu} />
        ) : (
          isLogged ? (
            <UserDropdown userNavItems={userNavItems} />
          ) : (
            <Link to={routes.login} className="nav-link">Ingresá</Link>
          )
        )}
      </div>
    </nav>
  );
}

export default NavBar;
